// extracted by mini-css-extract-plugin
export default {"horaLabel":"HoraCheckbox_horaLabel__ec825"};